import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export async function getReporteRetirosDashboard(id_dia: number) {
  const response = await axios.get(`${API_URL}retiro/reporte/${id_dia}`);
  return response.data?.doc?.data ?? [];
}

export async function getMontoLimiteRetiro(): Promise<number> {
  const response = await axios.get(`${API_URL}retiro/monto-limite`);
  return parseFloat(response.data?.doc?.data?.monto_limite ?? 0);
}

export async function getVentasPorCaja(ids_dia: number[]): Promise<any[]> {
  const response = await axios.get(`${API_URL}cortesias/ventas-por-caja`, {
    params: { ids_dia: ids_dia.join(',') },
  });
  return response.data?.doc?.data ?? [];
}
